import { render, staticRenderFns } from "./GroupCreate.vue?vue&type=template&id=79a9402c&scoped=true&"
import script from "./GroupCreate.vue?vue&type=script&lang=js&"
export * from "./GroupCreate.vue?vue&type=script&lang=js&"
import style0 from "./GroupCreate.vue?vue&type=style&index=0&id=79a9402c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a9402c",
  null
  
)

export default component.exports